module.exports = __webpack_public_path__ + "media/packs/autocatalog/components/mobile/SpecSummary/images/fuel-0d2f6b320f0e16821b3cb9a0d9a50a73.png";